import { useEffect } from 'react';

/**
 * Warns the user with a browser-native "unsaved changes" dialog
 * when they try to close the tab or navigate away while `hasUnsavedChanges` is true.
 */
export function useUnsavedChangesWarning(hasUnsavedChanges) {
  useEffect(() => {
    if (!hasUnsavedChanges) return;

    const handler = (e) => {
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [hasUnsavedChanges]);
}
